import React from 'react';

interface IProps {
  color?: string;
  className?: string;
}

const Arrow = ({color, className}: IProps) => {
  return (
    <svg className={className} width="25" height="25" viewBox="0 0 25 25" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M7 11L12 16L17 11" stroke={color || '#ADAFB2'} strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  );
};

export default Arrow;
